import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import { Box, Typography, Button } from "@mui/material";

// Dashboard components
import ProfileSection from "./components/profileSection";
import RegistrationSection from "./components/registrationSection";
import { API_URL } from "config";
import { useAuthContext } from "hooks/useAuthContext";

const GetStarted = ({ onClick }) => {
  const { user } = useAuthContext();
  const [academicYear, setAcademicYear] = useState("");
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [loading, setLoading] = useState(false); // Track loading state

  useEffect(() => {
    const fetchAcademicYears = async () => {
      try {
        const response = await fetch(`${API_URL}/academicyears/current`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch academic year");
        }

        const currentAcademicYear = await response.json();
        setAcademicYear(currentAcademicYear.year);
      } catch (error) {
        console.error("Error fetching academic year:", error);
      }
    };

    const fetchEnrollment = async () => {
      try {
        const response = await fetch(
          `${API_URL}/enrollment/getindividual/${encodeURIComponent(
            user.email
          )}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );

        if (response.ok) {
          setIsEnrolled(true);
        } else {
          setIsEnrolled(false);
        }
      } catch (error) {
        console.error("Error fetching enrollment:", error);
        setIsEnrolled(false);
      }
    };

    if (user) {
      fetchAcademicYears();
      fetchEnrollment();
    }
  }, [user]);

  // Function to enroll the student
  const handleEnroll = async () => {
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/enrollment/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({
          studentemail: user.email,
          enrolled: true,
          lastupdatedby: user.email,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to enroll student");
      }

      setIsEnrolled(true); // Update UI after successful enrollment
    } catch (error) {
      console.error("Error enrolling student:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={3}>
      {!isEnrolled && (
        <Grid item xs={12}>
          <Box bgcolor="error.main" p={2} textAlign="center" borderRadius={1}>
            <Typography
              variant="h6"
              fontWeight="bold"
              style={{ color: "white" }}
            >
              Warning: You must enroll for the current academic year! (
              {academicYear})
            </Typography>
            <Button
              variant="contained"
              color="warning"
              sx={{ mt: 1 }}
              onClick={handleEnroll}
              disabled={loading}
            >
              {loading ? "Enrolling..." : "Enroll Now"}
            </Button>
          </Box>
        </Grid>
      )}

      <Grid item xs={12} md={6} lg={8}>
        <ProfileSection />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <RegistrationSection onClick={onClick} isEnrolled={isEnrolled} />
      </Grid>
    </Grid>
  );
};

export default GetStarted;
